import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { UserCertificate, CertificateListParams } from '@/types';

export function useMyCertificates(params?: CertificateListParams) {
  return useQuery({
    queryKey: ['certificates', 'list', params],
    queryFn: () =>
      api.get<UserCertificate[]>('/certificates/mine', {
        page: params?.page ? String(params.page) : undefined,
        per_page: params?.per_page ? String(params.per_page) : undefined,
        position_id: params?.position_id ? String(params.position_id) : undefined,
      }),
    placeholderData: keepPreviousData,
  });
}
